import React, { useState, useEffect } from 'react';
import { Container, Grid, Paper, IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { SelectActive as ACTIVE } from 'Components/Api/OTTSettingAPI';
import { LOGOUT } from 'ConstComponents';
import OTTIcon from 'Components/DashboardIcon/OTTIcon';

const CustomContainer = HOCLoader(Container);
export const OTTIndexApp = () => {
    React.useEffect(() => {
        function handleEvent(event) {
            const dataString = event.data;
            const data = JSON.parse(dataString);

            localStorage.setItem('SecureToken', data?.SecureToken ?? '');
            localStorage.setItem('UserID', data?.UserID ?? '');
            localStorage.setItem('SecureToken', data?.SecureToken ?? '');

            selectActive();
        }
        document.addEventListener('message', handleEvent);

        return () => document.removeEventListener('message', handleEvent);
    }, []);

    const classes = commonStyle();
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const history = useHistory();
    const [Actives, setActive] = useState([]);

    const [NotActiveAPI, setNotActiveAPI] = useState(false);

    useEffect(() => {
        //selectActive();
    }, []);

    const selectActive = async () => {
        const response = await ACTIVE();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setNotActiveAPI(true);
        }

        let data = JSON.parse(response.data);

        if (data.length <= 0) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            setNotActiveAPI(true);
        }

        if (data.length <= 1) {
            handleClick(data[0].Name);
        }

        setActive(data);
    };

    const handleClick = (name) => {
        if (name.toLowerCase() === 'Paysprint'.toLowerCase()) {
            history.push('/OTTTransactionApp');
            return;
        } else {
            setIsError(true);
            setSeverity('error');
            setResponseMessage('No active API,Please contact to customer care');
            setNotActiveAPI(true);
        }
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            {NotActiveAPI ? (
                <Paper className={classes.PaperStyle}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            Please wait .....
                        </Grid>
                    </Grid>
                </Paper>
            ) : null}

            <Paper className={classes.PaperStyle}>
                <Grid container>
                    {Actives.map((account) => (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className="text-center"
                        >
                            <IconButton
                                color="primary"
                                className="dashmenu"
                                component="div"
                                onClick={() => {
                                    handleClick(account.Name);
                                }}
                            >
                                <OTTIcon name={account.DisplayName} />
                            </IconButton>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
